module.exports = __webpack_public_path__ + "static/media/calendar.7f16b513.svg";